<template>
      <div style="background:transparent;box-shadow: none;padding: 0; height: 100%">
          <sbspSalaryFilter :filterList.sync="filterList">
             <el-form-item label="工资月份：" style="margin-right:40px;">
              <div style="display: flex;align-items: center;">
                  <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:120px;" @change="dateWageChange()">
                    <el-option  v-for="item in filterList[0].options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker class="el-date" v-if="filterList[0].value=='92480004'" v-model="wageTime.month"  style="width:230px;margin-left:4px;"
                      type="monthrange"
                      range-separator="至"
											value-format="yyyy-MM"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份">
                  </el-date-picker>
              </div>
             </el-form-item>
          </sbspSalaryFilter>
					<div class="boxCon" :class="{'isCollapse':$store.getters.isCollapse}" style="padding-bottom: 0;">
						<div class="boxTop">
								<div>
									<span>批次信息</span>
								</div>
								<div>
									<span>工资信息</span>
								</div>
						</div>
					</div>
          <div class="boxCon dataList" v-loading="loading">
            <div v-if="dataLists.length== 0" style="margin: 0 auto;">
              <noData style="margin:40px 0;text-align: center" msg="暂无数据"></noData>
            </div>
								<list v-for="list in dataLists" :key="list.id"  :list="list">
									<div class="leftButtonCon" style="top: 0;">
										<leftButton v-if="list.editState=='10020001'" title="删除" @click="_deleteBatchById(list.id)" style="right:-38px;position: absolute;"></leftButton>
										<leftButton title="查看详情" @click="details(list)" ></leftButton>
									</div>
								</list>
              <div style="background:#fff; padding:16px 34px 0 0">
                <div class="block">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="msgPage.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="msgPage.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="msgPage.total">
                  </el-pagination>
                </div>
              </div>
          </div>
      </div>
</template>

<script>
	import { mapGetters } from 'vuex';
		import store from '@/store';
  import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
  import list from "@/wage-components/sbs-salary-card/list.vue"
  import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
  import {queryListPageQuery,deleteBatchById} from "@/api/wage/wageHis"
  import { queryPmsPayGroupTree } from "@/api/wage/payGroup";
  import noData from "@/wage-components/bsp-noData/bsp-noData.vue"

  export default {
    name: "approval",
    components: {
      sbspSalaryFilter,
      list,
      leftButton,
      noData
    },
		...mapGetters(['isCollapse']),
    data() {
      return {
        msgPage: {
              limit: 10,
              page: 1,
              total: 0,
              monthStr:'92480001',
							monthStart:'',
							monthEnd:'',
            },
        loading:false,
        wageTime:{
          month:'',
        },
        dataLists:[],
        filterList: [
      { text: "工资月份", type: 'select-timer',value:'92480002',name:'wageMonth',
        options:[{
            value: '92480001',
            label: '当前月'
          }, {
            value: '92480002',
            label: '近三个月'
          }, {
            value: '92480003',
            label: '近一年'
          },{
            value: '92480004',
            label: '其他'
          }
          ]
      },
      // { text: "批次名称", type: 'text',value:'',name:'batchName'},
          { text: "", type: 'text',value:'',name:'batchName'},
          { text: "薪酬组", type: 'treeSelect',value:[],multiple:true,name:'groupId',
          defaultGroupProps:{
              children: 'children',
              label: 'groupName',
              value: 'id',
          },
        options: []
      },
          {
            text: "社保月份",
            type: 'timer',
            value: '',
            name: 'socMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
          {
            text: "税金月份",
            type: 'timer',
            value: '',
            name: 'taxMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
       { text: "计税类型", type: 'select',value:[],multiple:true,name:'taxType',dicts:'9245',remNum:"92450002,92450004,92450007"}
    ]
      };
    },
		watch:{
				filterList:{//深度监听，可监听到对象、数组的变化
						handler(val, oldVal){
								val.map((item)=>{
										if(item.value2){
											this.$set(this.msgPage,item.name,item.value2);
										}else{
											if(item.value2==''&&item.value){
													this.$set(this.msgPage,item.name,item.value.split(','));
											}else{
												this.$set(this.msgPage,item.name,item.value);
											}
										}
								})
								this.$set(this.msgPage,'page',1);
								if(this.msgPage.wageMonth=='92480004'){
									return ;
								}
								this._queryListPageQuery();
						},
						deep:true //true 深度监听
				},
				wageTime:{
					handler(val, oldVal){

							let month = val.month;
							this.$set(this.msgPage,'monthStart',month[0]);
							this.$set(this.msgPage,'monthEnd',month[1]);
							this._queryListPageQuery();
						},
						deep:true //true 深度监听
				}

		},
    created(){
      this.filterLists = JSON.parse(JSON.stringify(this.filterList))
      this._queryPmsPayGroupTree() //查询薪酬组树
      this._queryListPageQuery();
    },
    methods: {
      //检查是否包含某 procId
      checkSegList(list){
        let ids = ['proc_0007','proc_0008','proc_0009'],
        arr = Array.isArray(list) ? Array.from(new Set(list.map(item=>item.procId))) : [],
        bom = arr.filter(val=> ids.indexOf(val) > -1 )
        return bom.length > 0
      },
			dateWageChange(val){
				if(this.filterList[0].value!='92480004'){
					this.$set(this.msgPage,'monthStart','');
					this.$set(this.msgPage,'monthEnd','');
				}
			},
      details(item){
        const query = {
            templateId: item.wageTmplId,
            batchId: item.id,
            region:'',
            orgId:'',
            payGroupId:'',
            wageMonth:item.wageMonth,
            socMonth:item.socMonth,
            taxMonth:item.taxMonth,
            payWay:item.payWay,
            isHistoryFlag:'',
            hasCiicSegName:this.checkSegList(item.segList)?1:0
        }
        this.$router.push({
            path: '/wage/salaryDetailTabs',
            query
        });
      },
      _queryListPageQuery(){
				this.loading = true;
        queryListPageQuery(this.msgPage).then(res =>{
          this.$set(this.msgPage,'limit',res.data.size);
          this.$set(this.msgPage,'page',res.data.current);
          this.$set(this.msgPage,'total',res.data.total);
          this.dataLists = res.data.records;
					this.loading = false;
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.$set(this.msgPage,'limit',val);
        this.handleCurrentChange(1)
      },
      handleCurrentChange(val) {
        this.$set(this.msgPage,'page',val);
        this._queryListPageQuery();
      },
      //获取薪酬组数据
      _queryPmsPayGroupTree() {
          queryPmsPayGroupTree().then(res => {
              let rs = res.data
              if (rs.code == 0) {
                  // this.filterList[2].value = [rs.data[0].id]
                  this.filterList[2].options = rs.data;
									// console.log(rs.data,222222222222222)
                  this.filterLists = JSON.parse(JSON.stringify(this.filterList));
              }
          })
      },
      //删除批次
        _deleteBatchById(batchId){
            this.$confirm('是否删除该批次数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((action) => {
                if(action === 'confirm'){
                    debugger;
                    let parm = {"batchId":batchId};
                    deleteBatchById(parm).then(res => {
                        debugger;
                        let rs = res.data
                        if (rs.code == 0) {
                            this.$message.success("删除成功");
                            this._queryListPageQuery();
                        }else{
                            this.$message.error(res.data.data.msg);
                        }
                    })
                }
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
      }
    }
  };
</script>

<style scoped>
.fixed{
  position: fixed;
  z-index: 20;
  width: calc(100vw - 204px);
  box-sizing: border-box;
  transition: .6s;
}
.isCollapse{
  width: calc(100vw - 88px);

}
/* 内容容器：整体圆角，视觉更柔和 */
.boxCon{
  background:#fff;
  padding:0 10px 40px 10px;
  border-radius: 8px;
}
/* 列表滚动区域 */
.dataList {
  height: calc(100% - 150px);
  overflow: auto;
  border-radius: 0 0 8px 8px;
}

/* 滚动条美化 */
.dataList::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.dataList::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 4px;
}
.dataList::-webkit-scrollbar-thumb:hover {
  background: #b8b8b8;
}
.dataList::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

/* 表头：保持灰色基调，叠加轻微渐变、圆角与内阴影，增强层次感 */
.boxTop{
  display:flex;
  background:linear-gradient(180deg, #eaeaea 0%, #e1e1e1 100%);
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  box-shadow: inset 0 -1px 0 #d6d6d6, 0 1px 2px rgba(0, 0, 0, .04);
  position: relative;
  z-index: 1;
}
.boxTop>div:nth-of-type(2){
  flex-grow:1;
}
.boxTop span{
  display:inline-block;
  height:38px;
  line-height:38px;
  font-size:14px;
  font-weight:600;
  color:#333;
  letter-spacing: .5px;
  text-align:center;
  transition: color .2s;
}
.boxTop>div:nth-of-type(1) span{
  width:301px;
  border-right:1px solid #d6d6d6;
  box-sizing: border-box;
}
.boxTop>div:nth-of-type(2) span{
  width:100%;

}

/* 表头与列表之间的分隔线，颜色更柔和 */
.boxCon>div:nth-last-of-type(2){
  border-top:1px solid #e8e8e8;
}

/* 分页区域美化 */
.dataList ::v-deep .el-pagination {
  padding: 8px 0;
  font-weight: 400;
  color: #606266;
}
.dataList ::v-deep .el-pagination .el-pager li {
  border-radius: 4px;
  transition: all .2s;
}
.dataList ::v-deep .el-pagination .el-pager li:not(.disabled).active {
  background: #409EFF;
  color: #fff;
  font-weight: 500;
}
.dataList ::v-deep .el-pagination .el-pager li:not(.disabled):hover {
  color: #409EFF;
  background: #ecf5ff;
}
</style>
